module.exports = __webpack_public_path__ + "img/2.e3da7a94.jpg";